import { regionIdMaps } from '@/utils';

export const useTableFormatter = () => {
    const useBoolFormatter = (field, trueLabel = '是', falseLabel = '否') => {
        return ({ row }) => {
            const { [field]: value = false } = row || {};
            return value ? (trueLabel || '是') : (falseLabel || '否');
        };
    };
    const useMergeFieldsFormatter = (sep = '', ...fields) => {
        return ({ row }) => {
            return fields.map(f => {
                return (row || {})[f] || '';
            }).join(sep);
        };
    };
    const useAreaFieldsFormatter = (provinceField = 'province', cityField = 'city', countyField = 'county') => {
        return ({ row }) => {
            const {
                [provinceField || 'province']: provinceIdOrName = '',
                [cityField || 'city']: cityIdOrName = '',
                [countyField || 'county']: countyIdOrName = '',
            } = row || {};
            let province = provinceIdOrName || '';
            let city = cityIdOrName || '';
            let county = countyIdOrName || '';
            if (provinceIdOrName && regionIdMaps[provinceIdOrName]) {
                province = regionIdMaps[provinceIdOrName].label;
            }
            if (cityIdOrName && regionIdMaps[cityIdOrName]) {
                city = regionIdMaps[cityIdOrName].label;
            }
            if (countyIdOrName && regionIdMaps[countyIdOrName]) {
                county = regionIdMaps[countyIdOrName].label;
            }
            return [ province, city, county ].join(' ');
        };
    };

    const useEnumFormatter = (field, defText, items = []) => {
        return ({ row }) => {
            const { [field]: value } = row || {};
            return items[value] || defText;
        };
    };

    const useKpiAuditFormatter = (field, defText) => {
        const names = [ '未提交审核', '待审核', '审核中', '审核未通过', '审核完成' ];
        return ({ row }) => {
            const { [field]: value } = row || {};
            return names[value] || defText;
        };
    };

    return {
        useBoolFormatter,
        useMergeFieldsFormatter,
        useAreaFieldsFormatter,
        useEnumFormatter,
        useKpiAuditFormatter,
    };
};
